import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import { Briefcase, Building2, GraduationCap, IndianRupee } from "lucide-react";
import type { MarriageProfileDto } from "src/types/Profile";
import type { ProfessionalInfo } from "src/types/matrimonyProfileDetails";
import InfoCard from "../InfoCard";
import KeyValueRow from "../KeyValueRow";
import EditButton from "../EditButton";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import { EMPLOYMENT_SECTOR_OPTIONS, getOptionLabel } from "src/utils/matrimonyOptions";

type ProfessionalSectionProps = {
  professional: ProfessionalInfo;
  dto: MarriageProfileDto;
  isOwnProfile: boolean;
  onEdit: () => void;
};

const ProfessionalSection: React.FC<ProfessionalSectionProps> = ({
  professional,
  dto,
  isOwnProfile,
  onEdit,
}) => (
  <InfoCard
    title="Professional Details"
    icon={<Briefcase size={18} />}
    rightSlot={isOwnProfile ? <EditButton onClick={onEdit} /> : null}
  >
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
      <KeyValueRow label={FIELD_LABELS.HIGHEST_EDUCATION} value={professional.education} icon={<GraduationCap size={20} />} />
      <KeyValueRow label={FIELD_LABELS.COLLEGE} value={professional.college} icon={<Building2 size={20} />} />
      <KeyValueRow label={FIELD_LABELS.ANNUAL_INCOME} value={professional.annualIncome} icon={<IndianRupee size={20} />} />
      <KeyValueRow label={FIELD_LABELS.COMPANY} value={professional.company} icon={<Briefcase size={20} />} />
      <KeyValueRow label={FIELD_LABELS.EMPLOYMENT_SECTOR} value={getOptionLabel(EMPLOYMENT_SECTOR_OPTIONS, dto.employmentSector)} icon={<Briefcase size={20} />} />
      <KeyValueRow label={FIELD_LABELS.DESIGNATION} value={dto.designation || ""} icon={<Briefcase size={20} />} />
    </SimpleGrid>
  </InfoCard>
);

export default ProfessionalSection;
